import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../api/appApi';
import Swal from 'sweetalert2';

const Header = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('access_token');
      const res = await logout(token);
      if (res?.success) {
        localStorage.removeItem('access_token');
        navigate('/login');
      } else {
        Swal.fire({ icon: 'error', title: 'Logout Failed', text: res.message || 'Unauthorized access.' });
      }
      setLoading(false);
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Logout Failed', text: err.response?.data?.message || 'Logout failed.' });
      setLoading(false);
    }
  };

  const handleChangePassword = () => {
    navigate('/change-password');
  };

  // Demo user data (replace with real user data as needed)
  const user = {
    name: 'Michael Thomas',
    email: localStorage.getItem('user_details') ? (JSON.parse(localStorage.getItem('user_details'))).email : 'michthoms123@yopmail.com',
    avatar: '/default_user.png',
  };

  return (
    <header className="pt-3 ps-3 pe-3 pt-md-3 p-md-0">
      <div className="container bg-white shadow-sm d-flex justify-content-between align-items-center header">
        <div className="d-flex align-items-center">
          <img src="/header_logo.png" alt="Logo" height="40" className="me-2 header-logo" />
        </div>
        <nav>
          <div className="dropdown">
            <button className="btn p-0" type="button" data-bs-toggle="dropdown">
              <img src="/default_user.png" alt="Profile" className="rounded-circle" width="32" height="32" />
            </button>
            <div className="dropdown-menu dropdown-menu-end profile-menu">
              {/* <div className="profile-title">My Profile</div> */}
              <div className="">
                <div className="d-flex align-items-center bg-light rounded user-details">
                  <img src="/default_user.png" alt="Profile" className="rounded-circle" width="44" height="44" />
                  <div className="">
                    {/* <div className="user-name">{user.name}</div> */}
                    <div className="user-email">{user.email}</div>
                  </div>
                </div>
                <button className="btn w-100 d-flex align-items-center justify-content-between menu-text change-pass" onClick={handleChangePassword}>
                  <span>Change Password</span>
                  <span className="">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.94629 3.52827C7.20664 3.26792 7.6293 3.26792 7.88965 3.52827L13.8897 9.52827C14.15 9.78862 14.15 10.2113 13.8897 10.4716L7.88965 16.4716C7.6293 16.732 7.20664 16.732 6.94629 16.4716C6.68594 16.2113 6.68594 15.7886 6.94629 15.5283L12.4746 9.99995L6.94629 4.47163C6.68594 4.21128 6.68594 3.78862 6.94629 3.52827Z" fill="#272C2F"/>
                    </svg>
                  </span>
                </button>
                <button className="btn w-100 d-flex align-items-center justify-content-between menu-text logout" onClick={handleLogout}>
                  <span>Logout</span>
                  <span className="">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.7104 12.7254V7.29167C2.71043 5.49132 3.07435 4.3929 3.73823 3.72884C4.40229 3.06478 5.50118 2.7002 7.30187 2.7002H7.41011C9.04036 2.7002 10.0968 2.99972 10.7727 3.54818C11.4313 4.08265 11.8414 4.94761 11.9625 6.35417C11.9923 6.69789 12.295 6.95262 12.6388 6.92301C12.9826 6.89337 13.2372 6.59056 13.2076 6.24674C13.0704 4.65354 12.5809 3.40535 11.5605 2.57731C10.5573 1.76327 9.15482 1.4502 7.41011 1.4502H7.30187C5.37756 1.4502 3.86747 1.83203 2.85444 2.84505C1.84163 3.85804 1.46043 5.3676 1.4604 7.29167V12.7254C1.46043 14.6495 1.84163 16.1591 2.85444 17.172C3.86747 18.1851 5.37756 18.5669 7.30187 18.5669H7.41011C9.14215 18.5669 10.5357 18.2578 11.5369 17.4569C12.5561 16.6415 13.0523 15.4115 13.1987 13.8411C13.2305 13.4976 12.9783 13.1936 12.6347 13.1616C12.291 13.1296 11.9864 13.3819 11.9544 13.7256C11.8258 15.1051 11.4142 15.9549 10.7565 16.4811C10.0806 17.0218 9.02803 17.3169 7.41011 17.3169H7.30187C5.50118 17.3169 4.40229 16.9523 3.73823 16.2882C3.07435 15.6242 2.71043 14.5258 2.7104 12.7254Z" fill="#F8285A"/>
                      <path d="M7.49919 9.375C7.15401 9.375 6.87419 9.65482 6.87419 10C6.87419 10.3452 7.15401 10.625 7.49919 10.625H16.9824C17.3276 10.625 17.6074 10.3452 17.6074 10C17.6074 9.65482 17.3276 9.375 16.9824 9.375H7.49919Z" fill="#F8285A"/>
                      <path d="M15.5677 6.76647C15.3237 6.52245 14.928 6.52256 14.6839 6.76647C14.4398 7.01055 14.4398 7.40618 14.6839 7.65026L17.0341 9.99971L14.6839 12.35C14.4398 12.594 14.4398 12.9897 14.6839 13.2338C14.928 13.4776 15.3237 13.4778 15.5677 13.2338L18.359 10.4416C18.6029 10.1975 18.603 9.80184 18.359 9.55781L15.5677 6.76647Z" fill="#F8285A"/>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className="container my-4">
        <div className="row">
          <div className="col-md-6 col-sm-12 col-12 text-center text-md-start m-auto ps-md-0">
            <h1 className="banner-title">AI virtual try ons<br /> video generator</h1>
            <p className="banner-subtitle">AI-powered trial for your favorite clothes</p>
          </div>
          <div className="col-md-6 col-sm-12 col-12 text-center text-md-end pe-md-0">
            <img src="/banner_home.png" alt="banner" className="banner-img" />
          </div>
        </div>
      </div>
      {loading && <div className="page-loader"><span className="spinner-border" /></div>}
    </header>
  );
};

export default Header;
